<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Ana Grup</label>
            <v-validator :errors="errors" parameter="MainGroupOfMaintenanceInventoryId" :watch="mainGroup"> 
              <v-select-list v-model="mainGroup" :disabled="editing" label="Name" placeholder="Ana Grup" :options="mainGroups"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Alt Grup</label>
            <v-validator :errors="errors" parameter="SubGroupOfMaintenanceInventoryId" :watch="subGroup"> 
              <v-select-list :disabled="!mainGroup || editing" v-model="subGroup" label="Name" placeholder="Alt Grup" :options="subGroups"/>
            </v-validator>
            </div>
        <div class="col-12 mb-1">
            <label class="form-label">Eski Stok Kodu</label>
            <v-validator :errors="errors" parameter="StockCode" :watch="value.StockCode"> 
              <input type="text" v-model="value.StockCode" class="form-control" placeholder="Eski Stok Kodu" />
            </v-validator>
            </div>
        <div class="col-12 mb-1">
            <label class="form-label">Parça Adı</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name"> 
             <input type="text" v-model="value.Name" class="form-control" placeholder="Parça Adı" />
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <b-form-checkbox v-model="value.IsGlobalPart">Universal/Global Parça</b-form-checkbox>
        </div>
        <div class="col-12 mb-1"  v-if="!value.IsGlobalPart">
            <label class="form-label">Araçlar</label>
            <v-validator :errors="errors" parameter="VehicleIds" :watch="vehicle">
              <v-select-list v-model="vehicle" multiple label="Vehicle" placeholder="Araçlar" :options="vehicles"/>
            </v-validator>
        </div>
        <div class="col-12">
            <part-of-location v-model="value"></part-of-location>
        </div>
    </div>
</template>

<script>

import { BFormCheckbox } from 'bootstrap-vue'
import MaintenanaceOperationsApi from '@/api/maintenance-operations'
import VehicleDefinitionsApi from '@/api/vehicle-definitions'
import PartOfLocation from './PartOfLocation.vue'
import VValidator from '@/components/VValidator.vue'
export default {
    components:{
        BFormCheckbox,
        PartOfLocation,
        VValidator
    },
    props:{
        value:Object,
        errors:Object,
        editing:Boolean,
    },
    data(){
        return{
            mainGroups:[],
            subGroups:[],
            vehicles:[]
        }
    },
    watch:{
        "value.MainGroupOfMaintenanceInventoryId"(nevV,oldV){
            if(nevV != oldV){
                this.getSubGroups()
                this.value.SubGroupOfMaintenanceInventoryId = null
            }
        }
    },
    mounted(){
        this.getMainGroups()
        this.getSubGroups()
        this.getVehicles()
    },
    methods:{
        getMainGroups(){
            MaintenanaceOperationsApi.MainGroup.List().then(res=>{
                this.mainGroups = res.data.Data
            })
        },
        getSubGroups(){
            if(this.value.MainGroupOfMaintenanceInventoryId){
                MaintenanaceOperationsApi.SubGroup.List(this.value.MainGroupOfMaintenanceInventoryId).then(res=>{
                    this.subGroups = res.data.Data
                })
            }
        },
        getVehicles(){
            VehicleDefinitionsApi.Vehicle.List().then(res=>{
                this.vehicles = res.data.Data
            })
        }
    },
    computed:{
        mainGroup:{
            get:function(){
                return this.mainGroups.find(m=>m.Id==this.value.MainGroupOfMaintenanceInventoryId)
            },
            set:function(value){
                this.value.MainGroupOfMaintenanceInventoryId = value?.Id || null
            }
        },
        subGroup:{
            get:function(){
                return this.subGroups.find(s=>s.Id==this.value.SubGroupOfMaintenanceInventoryId)
            },
            set:function(value){
                this.value.SubGroupOfMaintenanceInventoryId = value?.Id || null
            }
        },
        vehicle:{
            get:function(){
                return this.vehicles.filter(v=>this.value.VehicleIds.includes(v.Id))
            },
            set:function(value){
                this.value.VehicleIds = value?.map(v=>v.Id) || []
            }
        },
    }
}
</script>

<style lang="scss">
</style>